"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

var SvgUnlock = function SvgUnlock(props) {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M29.88 18.801a1 1 0 01-1.96.398A4 4 0 0020 20l-.001 3H31a3 3 0 013 3v7a3 3 0 01-3 3H17a3 3 0 01-3-3v-7a3 3 0 013-3h.999L18 20a6 6 0 0111.88-1.2zM31 25H17a1 1 0 00-1 1v7a1 1 0 001 1h14a1 1 0 001-1v-7a1 1 0 00-1-1z",
    id: "unlock_svg__a"
  }));
};

var _default = SvgUnlock;
exports["default"] = _default;